export default __webpack_public_path__ + "static/seyfeli-header-image-53a3397cfd8248966f9d591a961e5924.jpg";